import CircularProgress from '@mui/material/CircularProgress'
import moment from 'moment'
import { forwardRef, useImperativeHandle, useState } from 'react'
import OrderSummary from '../order-summary/OrderSummary'
import styles from './styles.module.css'
import { ICustomer } from '../../../../../../../app/entities/Customer'
import { ICustomerVehicle } from '../../../../../../../app/entities/CustomerVehicle'
import { IInstallationPoint } from '../../../../../../../app/entities/InstallationPoint'
import { ITiresCombination } from '../../../../../../../app/entities/TiresCombination'
import { IOrder } from '../../../../../../../app/entities/Order'
import { fetchData } from '../../../../../global/helper-functions/fetch'

interface IConfirmationAppointment {
  customer: Partial<ICustomer>
  customerVehicle: Partial<ICustomerVehicle>
  installationPoint: Partial<IInstallationPoint>
  tiresCombination: Partial<ITiresCombination>
  order: Partial<IOrder>
  selectedTimes: number[]
  isRework: boolean
  disposalCount: number
  handleClosed: Function
  setForwardButtonCopy: Function
  locationId: string
}

export const ConfirmAppointment = forwardRef(
  (
    {
      customer,
      installationPoint,
      tiresCombination,
      customerVehicle,
      order,
      selectedTimes,
      isRework,
      handleClosed,
      disposalCount,
      setForwardButtonCopy,
      locationId,
    }: IConfirmationAppointment,
    ref?,
  ) => {
    const time = selectedTimes[0]
    const [isLoading, setIsLoading] = useState(false)

    const [isScheduled, setIsScheduled] = useState(false)

    useImperativeHandle(ref, () => ({
      async useNextClick() {
        if (isScheduled) {
          handleClosed()
        } else {
          setIsLoading(true)
          try {
            await fetchData({
              method: 'POST',
              url: `${process.env.REACT_APP_ORIGIN}/orders`,
              body: {
                customer,
                customerVehicle,
                installationPoint,
                tiresCombination,
                order,
                selectedTimes,
                isRework,
                disposalCount,
                locationId,
              },
            })
            setForwardButtonCopy('Done')
            setIsScheduled(true)
          } catch (err) {
            console.error(err)
            alert('Something went wrong, please try again later.')
          } finally {
            setIsLoading(false)
          }
        }
      },
    }))
    return (
      <div className={styles.confirmAppointmentContainer}>
        {isLoading && (
          <div className={styles.overlay}>
            <div className={styles.progressContainer}>
              <CircularProgress size={80} />
            </div>
          </div>
        )}
        <div className={styles.appointmentContainer}>
          <div className={styles.appointmentTimeContainer}>
            <div className={styles.appointmentTimeContainerTitle}>
              Appointment
            </div>
            <div className={styles.confirmAppointmentSmallText}>
              {moment.utc(time).format('MMMM Do YYYY, h:mm a')}
            </div>
          </div>
          <div className={styles.appointmentTimeContainer}>
            <div className={styles.appointmentTimeContainerTitle}>
              Installation Address
            </div>
            <div className={styles.confirmAppointmentSmallText}>
              {installationPoint.address}
            </div>
            <div
              className={styles.confirmAppointmentSmallText}
            >{`${installationPoint.city}, ${installationPoint.state} ${installationPoint.zipCode}`}</div>
          </div>
          <div className={styles.appointmentTimeContainer}>
            <div className={styles.appointmentTimeContainerTitle}>Vehicle</div>
            <div className={styles.confirmAppointmentSmallText}>
              {customerVehicle.brand?.name}
            </div>
            <div className={styles.confirmAppointmentSmallText}>
              {customerVehicle.model}
            </div>
            <div className={styles.confirmAppointmentSmallText}>
              {customerVehicle.year}
            </div>
            <div className={styles.confirmAppointmentSmallText}>
              {customerVehicle.variant}
            </div>
          </div>
          <div className={styles.appointmentTimeContainer}>
            <div className={styles.appointmentTimeContainerTitle}>Contact</div>
            <div
              className={styles.confirmAppointmentSmallText}
            >{`${customer.firstName} ${customer.lastName}`}</div>
            <div
              className={styles.confirmAppointmentSmallText}
            >{`${customer.email}`}</div>
            <div
              className={styles.confirmAppointmentSmallText}
            >{`${customer.phoneNumber}`}</div>
          </div>
        </div>
        <div>
          <OrderSummary
            tiresCombination={tiresCombination}
            isRework={isRework}
          />
          {isScheduled && (
            <div className={styles.confirmationMessage}>
              The appointment has been scheduled 🥳
            </div>
          )}
        </div>
      </div>
    )
  },
)
